import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import axios from "axios";
const MobileNavbarManager = (props) => {
    const { t, i18n } = useTranslation()
    const { user } = useAuth();
    const [logo, setLogo] = useState('');

    const getlogo = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
            await axios({
                method: 'get',
                url: "https://express.heryerdeingilizce.com/getlogo",
                headers: headerss
            }).then(res => {
                setLogo(res.data[0])
            }
            );
        }
        catch (err) {
        }
    }
    useEffect(() => {
        getlogo();
    }, [])
    return (
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
            <div className="container-fluid" style={{ backgroundColor: "white" }}>
                <a className="navbar-brand" href="/">
                    <img src={logo['photo']} alt="logo" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                        <a href={"/school/editschool/" + user.userDetail.schoolId} >
                            <b> {t('editSchool')}</b>
                        </a>
                        <hr />
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                <b> {t('teachers')}</b>
                            </a>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" href="/school/teachercreate">                                    {t('createteacher')}
                                </a></li>
                                <li><a className="dropdown-item" href="/school/teacherlist">  {t('teachersList')}</a></li>
                            </ul>
                        </li>
                        <hr />
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                <b> {t("classes")}</b>
                            </a>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" href="/school/classlist">                                   {t("classlist")}
                                </a></li>
                                <li><a className="dropdown-item" href="/school/createclass"> {t("createclass")}</a></li>
                            </ul>
                        </li>
                        <hr />
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                                <b> {t("students")}</b>
                            </a>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" href="/school/studentcreate">                                   {t("createstudent")}
                                </a></li>
                                <li><a className="dropdown-item" href="/school/studentlist"> {t("studentList")}</a></li>
                            </ul>
                        </li>
                    </ul>
                    <hr />
                    <form className="d-flex" style={{ padding: "3%" }}>
                        <a href="/profile">
                            <i
                                className="fa fa-user-circle"
                                style={{ fontSize: 30 }}
                                aria-hidden="true"
                            >
                            </i>
                            &nbsp;
                            <span>

                                <strong>{user.name}</strong>
                                <br />
                                {user.role}
                            </span>
                        </a>
                    </form>
                </div>
            </div>
        </nav>
    );
};

export default MobileNavbarManager;